import { Controller } from 'stimulus';
import { MouseEvent } from 'react';

export default class LessonSubmitVocabController extends Controller {
  static targets = ['rawVocabInput'];

  rawVocabInputTarget: HTMLInputElement;

  toggleNoVocab(evt: MouseEvent<HTMLInputElement>) {
    this.rawVocabInputTarget.disabled = (evt.target as any).checked;
  }
}
